import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const TextCTA = ({ 
  children, 
  href, 
  external = false,
  showArrow = true,
  className = '' 
}) => {
  const baseClasses = `text-cta ${className}`;
  
  const content = (
    <>
      {children}
      {showArrow && <ArrowRight />}
    </>
  );

  if (external || href?.startsWith('mailto:')) {
    return (
      <a 
        href={href} 
        className={baseClasses}
        target={external && !href?.startsWith('mailto:') ? "_blank" : undefined}
        rel={external && !href?.startsWith('mailto:') ? "noopener noreferrer" : undefined}
      >
        {content}
      </a>
    );
  }

  return (
    <Link to={href} className={baseClasses}>
      {content}
    </Link>
  );
};

export default TextCTA;
